<template>

    <SegmentoCommon v-model="properties" />

</template>

<script setup>

import {ref} from 'vue'
import SegmentoCommon from "@/reports/components/SegmentoCommon"

const properties = defineModel()

const props = defineProps({
    "isNew": {
        type: Boolean,
        default: false
    }
})

</script>
